import {SureFlowUnitData} from './sure-flow-unit-data';

export class EntitySureFlowUnit {

  id!: number;
  loopId!: number;
  entityLineId!: string;
  unitData!: SureFlowUnitData;
  sequence!: number;

}
